// Convert kebab-case to camelCase: my-page-asset > myPageAsset
export const camelize = s => s.replace(/-(.)/g, l => l[1].toUpperCase());

export const ucfirst = s => s ? s[0].toUpperCase() + s.slice(1) : s;

export const isStringAndNotEmpty = s => typeof s !== 'undefined' && s !== null && typeof s === 'string' && s.trim() !== '';

export const getOrdinalSuffix = num => {
  if (typeof num !== 'number') return num;

  const remainder = num % 10;
  const tens = num % 100;

  if (tens >= 11 && tens <= 13) return `${num}th`;

  switch (remainder) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
};

export const getDifficultyString = depth => {
  if (depth > 100) return 'technical';
  if (depth > 60) return 'advanced';
  if (depth > 30) return 'intermediate';
  if (depth > 16) return 'beginner';
  return 'snorkeling';
}
